import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import {
  IconMail,
  IconPlus,
  IconQuestionMark,
  TablerIcon,
} from '@rossum/ui/icons/tabler';
import { Divider, Link, Paper, Stack, SvgIcon } from '@rossum/ui/material';
import { FIRST_EXTENSION_LINK } from '../../../../constants/values';
import { boldText, gray } from '../../../../lib/formaterValues/index';
import { extensionsCreatePath, extensionsStorePath } from '../../routes';

const HintIcon = ({ Icon }: { Icon: TablerIcon }) => {
  return (
    <Stack component={Paper} elevation={8} p={0.5} mr={1} borderRadius="50%">
      <SvgIcon fontSize="large" color="primary">
        <Icon />
      </SvgIcon>
    </Stack>
  );
};

export const StoreHints = () => (
  <Stack component={Paper} alignItems="center" p={3} mt={3}>
    <Stack maxWidth={520} width={1} gap={2} divider={<Divider />}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <HintIcon Icon={IconPlus} />
          <div>
            <FormattedMessage
              id="containers.settings.extensions.store.hints.createYourOwn.text"
              values={{ gray, boldText }}
            />
          </div>
        </Stack>
        <Link
          component={RouterLink}
          data-cy="extension-store-create"
          to={{
            pathname: extensionsCreatePath(),
            state: { backLink: extensionsStorePath() },
          }}
        >
          <FormattedMessage id="containers.settings.extensions.store.hints.createYourOwn.link" />
        </Link>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <HintIcon Icon={IconQuestionMark} />
          <div>
            <FormattedMessage
              id="containers.settings.extensions.store.hints.howTo.text"
              values={{ gray, boldText }}
            />
          </div>
        </Stack>
        <Link
          data-cy="extension-store-read-more"
          href={FIRST_EXTENSION_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="containers.settings.extensions.store.hints.howTo.link" />
        </Link>
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <HintIcon Icon={IconMail} />
          <div>
            <FormattedMessage
              id="containers.settings.extensions.store.hints.wantSubmit.text"
              values={{ gray, boldText }}
            />
          </div>
        </Stack>
        <Link
          href="mailto:product@rossum.ai?subject=Interested in placing my extension to Rossum Store"
          data-cy="extension-store-contact-us"
        >
          <FormattedMessage id="containers.settings.extensions.store.hints.wantSubmit.link" />
        </Link>
      </Stack>
    </Stack>
  </Stack>
);
